












import { Mixins, Component, Inject } from "vue-property-decorator";
import { ICProdProvider } from "@/models/providers/contractProduct";
import { Location } from "vue-router";
import Context from "@/mixins/context";

@Component
export default class CProdMovedMsg extends Mixins(Context) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProductProviderData!: () => ICProdProvider;

  // Computed

  public get cProdData() {
    return this.$cProductProviderData();
  }

  public get isVisible() {
    if (!this.isAdmin) return false;
    return this.cProdData.hasMoved;
  }

  public get newCProdRoute(): Location {
    const { contract, contractProduct } = this.cProdData;
    return {
      name: "adminClientCProdOverview",
      params: {
        clientId: contract.moved_to_contract.client_id,
        contractId: contract.moved_to_contract.id,
        productId: contractProduct.moved_to_contract_product_id
      }
    };
  }
}
